//src/components/CategoryCards.js
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { getHomepageCategoryCards } from "../services/homepage.api";

function CategoryCards() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);

  useEffect(() => {
    getHomepageCategoryCards().then(setCards).catch(console.error);
  }, []);

  const openCard = (card) => {
    const target = card.link_target || `/products?category=${encodeURIComponent(card.key)}`;
    if (typeof target !== "string") return;
    if (target.startsWith("/") && !target.startsWith("//")) {
      navigate(target, { state: { from: "home" } });
    } else if (/^https:\/\//i.test(target)) {
      try {
        const url = new URL(target);
        if (url.protocol === "https:") window.location.assign(url.href);
      } catch (_) { /* Ignore malformed URL */ }
    }
  };

  const card = cards[0];
  if (!card) return null;
  const title = lang === "AR" ? card.title_ar : card.title_en;
  return (
    <section className="w-full mt-16 mb-0 overflow-hidden">
      <button
        type="button"
        onClick={() => openCard(card)}
        aria-label={title || "Explore collection"}
        className="relative block w-full p-0 text-left bg-gray-200 overflow-hidden group rounded-none"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={card.desktop_image || card.mobile_image} />
          <img
            src={card.mobile_image || card.desktop_image}
            alt={title || "Category promotion"}
            className="block w-full h-auto md:h-[400px] md:object-cover transition-transform duration-700 group-hover:scale-[1.015]"
          />
        </picture>
        <span className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors pointer-events-none" />
        <span className="absolute bottom-4 left-0 right-0 text-center text-white drop-shadow-md pointer-events-none">
          <span className="block text-sm md:text-xl font-semibold tracking-wide">{title}</span>
          <span className="block underline text-xs md:text-sm tracking-wider mt-1">{lang === "AR" ? "استكشف" : "EXPLORE"}</span>
        </span>
      </button>
    </section>
  );
}

export default CategoryCards;
